const errors = {
  DEFAULT: 'errors.err_default',
  500: {
    DEFAULT: 'errors.err_default'
  },
  503: {
    SLAM_PLATFORM_UNAVAILABLE: 'errors.err_503.slam',
    AREELEC_DATABASE_UNAVAILABLE: 'errors.err_503.areelec'
  },
  401: {
    DEFAULT: 'errors.err_401.default',
    AUTH_TOKEN_COMPROMISED: 'errors.err_401.token',
    AUTH_INVALID_CREDENTIALS: 'errors.err_401.credentials'
  },
  404: {
    DEFAULT: 'errors.err_404.default',
    ORDER_NOT_FOUND: 'errors.err_404.order',
    THIS_CAR_HAS_NOT_GPS_INFORMATION: 'errors.err_404.gps'
  },
  422: {
    DEFAULT: 'errors.err_default',
    YOU_HAVE_CREATED_AN_ORDER: 'errors.err_422.order',
    SESSION_EXPIRED: 'errors.err_422.session',
    UNAUTHORIZED: 'errors.err_422.unauthorized',
    INVALID_SESSION: 'errors.err_422.invalid_session',
    INVALID_TOKEN: 'errors.err_422.invalid_token',
    INVALID_SLAM_STATUS: 'errors.err_422.invalid_slam_status',
    INVALID_AREELEC_STATUS: 'errors.err_422.invalid_areelec_status',
    INVALID_EXTENSION_FILE: 'errors.err_422.invalid_extension_file',
    100: {
      DEFAULT: 'errors.err_default',
      email: 'errors.err_422.100.email',
      token: 'errors.err_422.invalid_token'
    }
  }
}

const getError = (t, status, code = 'DEFAULT', fields = []) => {
  if (fields.length > 0) {
    let _errors = []
    const _status = errors[status] ? status : 500
    const _code = 100
    for (const field of fields) {
      _errors.push(errors[_status][_code][field.field])
    }
    return _errors
  }
  const _status = errors[status] ? status : 500
  const _code = errors[_status][code] ? code : 'DEFAULT'
  return t(errors[_status][_code])
}

export default getError
